import { buildWallMap } from './walls.mjs';

const FACE_SIZE = 8;

// Corner order is load-bearing: a canonical face (void cell at local 7,7, which
// is how it sits in the top-left) is turned index × 90° clockwise to fit the
// corner at that index. An arrangement array is indexed by this.
const CORNERS = ['TL', 'TR', 'BR', 'BL'];

const ORIGINS = { TL: [0, 0], TR: [8, 0], BR: [8, 8], BL: [0, 8] };
const NEXT_SIDE_CW = { top: 'right', right: 'bottom', bottom: 'left', left: 'top' };

function rotateCoord(x, y, turns) {
  for (let i = 0; i < turns; i++) [x, y] = [FACE_SIZE - 1 - y, x];
  return [x, y];
}

function rotateSide(side, turns) {
  for (let i = 0; i < turns; i++) side = NEXT_SIDE_CW[side];
  return side;
}

// `arrangement` is face ids indexed by CORNERS: ['A','B','C','D'] puts A in the
// top-left unrotated, B in the top-right turned 90° CW, and so on.
function assembleBoard(faces, arrangement) {
  const byId = new Map(faces.map(f => [f.id, f]));
  const missions = [];
  const extraWalls = [];

  arrangement.forEach((faceId, turns) => {
    const face = byId.get(faceId);
    if (!face) throw new Error(`assembleBoard: unknown face id "${faceId}"`);
    const [ox, oy] = ORIGINS[CORNERS[turns]];

    for (const target of face.targets) {
      const [x, y] = rotateCoord(target.x, target.y, turns);
      missions.push({
        name: target.name,
        color: target.color,
        shape: target.shape,
        x: ox + x,
        y: oy + y,
        walls: target.walls.map(side => rotateSide(side, turns)),
      });
    }

    for (const wall of face.walls) {
      const [x, y] = rotateCoord(wall.x, wall.y, turns);
      extraWalls.push({ x: ox + x, y: oy + y, side: rotateSide(wall.side, turns) });
    }
  });

  return { walls: buildWallMap(missions, extraWalls), missions };
}

// With exactly four faces this is a permutation. If faces are added later it
// becomes a choice of four from the set, which changes only this function.
function randomArrangement(faces, rng = Math.random) {
  const ids = faces.map(f => f.id);
  for (let i = ids.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [ids[i], ids[j]] = [ids[j], ids[i]];
  }
  return ids.slice(0, CORNERS.length);
}

export { assembleBoard, randomArrangement, CORNERS };
